import { useState } from "react";
import { QUICKSTART } from "../content";

export function Quickstart() {
  const [i, setI] = useState(0);
  return (
    <section className="section" style={{ background: "var(--bg-2)" }}>
      <div className="wide">
        <div className="rule">
          <span className="label">Quickstart</span>
        </div>
        <div className="qs">
          <div>
            <h2 className="xl" style={{ marginBottom: "var(--s5)" }}>
              Four steps, and the last one is a stranger checking your work.
            </h2>
            <div className="qs-steps" id="qs-steps">
              {QUICKSTART.map((s, n) => (
                <button
                  className={`qs-step ${n === i ? "on" : ""}`}
                  key={s.h}
                  onClick={() => setI(n)}
                  data-testid={`qs-step-${n}`}
                >
                  <span className="n">0{n + 1}</span>
                  <span>
                    <h4>{s.h}</h4>
                    <p>{s.p}</p>
                  </span>
                </button>
              ))}
            </div>
          </div>
          <pre className="code" id="qs-code" data-testid="qs-code">
            {QUICKSTART[i].code}
          </pre>
        </div>
      </div>
    </section>
  );
}
